export default __webpack_public_path__ + "static/flow-poster-image-default-ee3cd8cdb7334e5ac58e0dbe74556ff7.png";